import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

@Injectable()
export class WorkflowApiInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(this.handleWorkflowApiRequests(request));
    }

    private handleWorkflowApiRequests(request: HttpRequest<any>, auth: string | null = null): HttpRequest<any> {
        const workflowApiUrl = `mediahaven-rest-api/workflow/api`;
        const isWorkflowApiRequest: boolean = request.url.includes(workflowApiUrl);

        if (isWorkflowApiRequest) {
            const url: string = request.url.replace(workflowApiUrl, 'workflow/api');

            return request.clone({ url });
        }
        return request;
    }
}
